import { BaseAPI } from './BaseAPI.js'
import { ChannelOutcome } from '../types/index.js'

export default class ChannelOutcomesAPI extends BaseAPI<ChannelOutcome> {
  override get resource(): string {
    return '/channelOutcomes'
  }
}
